import React from 'react'
import {
  Button,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Table,
  TableRow,
  TableCell,
  Typography
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';

export const ObraDiarioModalAnexo = ({ modal, toggle, props, anexos }) => {

  const { classes, className, ...rest } = props
  const { match: { params } } = props;

  const handleClose = () => {
    toggle();
  }

  const handleOpenImagem = (link) => {
    window.open(link);
  }

  return (
    <Dialog
      open={modal}
      fullWidth
      style={{ padding: 0, margin: 0 }}
      maxWidth='md'
      onClose={toggle}
    >
      <DialogTitle>
        <Grid alignItems="flex-end" container justifyContent="space-between" spacing={3}>
          <Grid item>
            <Typography style={{ fontSize: "16px", fontWeight: 'bold', textAlign: "left", marginRight: 5 }}>
              ANEXOS
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            style={{ backgroundColor: '#000', position: 'relative', marginTop: 15 }}
            onClick={() => handleClose()}>
            <CloseIcon />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent style={{ padding: 0, margin: 0 }}>
        <Card style={{ marginTop: 0, paddingLeft: 8, paddingRight: 8, paddingBottom: 8 }}>
          <Grid
            container
            spacing={2}
            direction="column"
            justifyContent="center"
            alignItems="center"
            alignContent="center"
          >
            <Table fullWidth>
              {undefined !== anexos && anexos.length
                ? anexos.map((n) => {
                  return (
                    n.caminhoAnexo.endsWith('png') || n.caminhoAnexo.endsWith('jpg') || n.caminhoAnexo.endsWith('jpeg') || n.caminhoAnexo.endsWith('webp') ?
                      <TableRow style={{ margin: 4, justifyContent: 'center' }} key={n.id} >
                        <TableCell align="center">
                          <img
                            style={{ borderRadius: 10, backgroundSize: 'cover', width: 180, height: 160, cursor: 'pointer' }}
                            src={n.caminhoAnexo}
                            onClick={() => handleOpenImagem(n.caminhoAnexo)}
                            alt={n.caminhoAnexo}
                            loading="lazy"
                          />
                        </TableCell>
                      </TableRow>
                      :
                      <TableRow style={{ margin: 4 }} key={n.id}>
                        <TableCell align="center">
                          <span style={{ cursor: 'pointer' }} onClick={() => handleOpenImagem(n.caminhoAnexo)}>{n.caminhoAnexo}</span>
                        </TableCell>
                      </TableRow>
                  )
                }) : <TableRow style={{ margin: 4 }} key={`nenhum-anexo`}>
                  <TableCell align="center">
                    Nenhum anexo para ser exibido
                  </TableCell>
                </TableRow>
              }
            </Table>
          </Grid>
        </Card >
      </DialogContent >
    </Dialog >
  )
}
